import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { Box } from '@mui/material';

import Message from './Message';

import {
  uiStateForContactSelector,
  setInitialRenderForContact,
} from '../nfChatSlice';

const Messages = ({
  messages,
  currentUser,
  currentContact,
  onScrolledToTop,
  perPage,
}) => {
  const scrollableContainerRef = useRef(null);
  const dispatch = useDispatch();

  // this is used to keep our place in the scroll
  // when we load more messages. don't jump to the top
  const earliestLoadedMessageRef = useRef(null);

  const uiState = useSelector((state) => {
    return uiStateForContactSelector(state, currentContact?.id);
  });

  const scrollToBottom = () => {
    if (scrollableContainerRef.current && messages.length > 0) {
      scrollableContainerRef.current.scrollTop =
        scrollableContainerRef.current.scrollHeight;
    }
  };

  const onMessagesScroll = (e) => {
    const { scrollTop } = e.target;
    if (scrollTop === 0) onScrolledToTop();
  };

  useEffect(() => {
    if (messages.length === 0) return;

    if (uiState.initialRender) {
      scrollToBottom();

      dispatch(setInitialRenderForContact({
        contactId: currentContact.id,
        initialRender: false,
      }));
    } else if (earliestLoadedMessageRef.current) {
      earliestLoadedMessageRef.current.scrollIntoView();
    }
  }, [messages]);

  useEffect(() => {
    // when we switch contacts, scroll to the bottom
    scrollToBottom();
  }, [currentContact]);

  if (!messages || messages.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <Box
      className="MESSAGES"
      ref={scrollableContainerRef}
      onScroll={onMessagesScroll}
      sx={{
        margin: '10px',
        overflow: 'scroll',
        height: 'calc(100vh - 350px)',
        width: '100%',
      }}
    >
      {messages.map((message, index) => {
        return (
          <Message
            ref={index === (perPage - 1) ? earliestLoadedMessageRef : null}
            message={message}
            key={message.id}
            currentUserId={currentUser.id}
          />
        );
      })}
    </Box>
  );
};

Messages.defaultProps = {
  messages: null,
  currentUser: null,
  currentContact: null,
};

Messages.propTypes = {
  messages: PropTypes.array,
  currentUser: PropTypes.object,
  onScrolledToTop: PropTypes.func.isRequired,
  currentContact: PropTypes.object,
  perPage: PropTypes.number.isRequired,
};

export default Messages;
